import { Component, OnInit, Input, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Platform } from '@ionic/angular';
import { ImportantTaskCard } from '@bluecrew/crew-member-backend-angular-client';
import { SwiperOptions } from 'swiper';
import { SwiperComponent } from "swiper/angular";

@Component({
  selector: 'app-important-tasks-card-carousel',
  templateUrl: './important-tasks-card-carousel.component.html',
  styleUrls: ['./important-tasks-card-carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImportantTasksCardCarouselComponent implements OnInit {

  readonly APP_IS_ON_DESKTOP: boolean = this.platform.is('desktop');
  enablePrevBtn: boolean = false;
  enableNextBtn: boolean = false;
  currentCardSlideIndex: number;

  carouselConfig: SwiperOptions = {
    centeredSlides: false,
    grabCursor: true,
    observer: true,
    observeParents: true,
    spaceBetween: 12,
    width: 220,
  };

  @ViewChild('swiper', { static: false }) swiper?: SwiperComponent;

  @Input() taskCards: ImportantTaskCard[];

  constructor(
    private platform: Platform,
    private cd: ChangeDetectorRef
    ) { }

  ngOnInit() {
    if (this.APP_IS_ON_DESKTOP) {
      if (this.taskCards?.length === 1) {
        this.enablePrevBtn = false;
        this.enableNextBtn = false;
      } else {
        this.enablePrevBtn = false;
        this.enableNextBtn = true;
      }
    }
  }

  goToCardSlide(cardSlideIndex: number) {
    if (this.taskCards && this.swiper?.swiperRef && this.currentCardSlideIndex !== cardSlideIndex) {
      // false here prevents ionSlideDidChange event from being emitted to avoid extra calls
      this.swiper.swiperRef.slideTo(cardSlideIndex, undefined, false);
      // need to check this here since we prevent events emitted with slideTo() above
      this.checkFirstOrLastSlide();
    }
  }

  cardSlideChangeEvent() {
    this.checkFirstOrLastSlide();
  }

  nextSlide() {
    this.swiper.swiperRef.slideNext();
  }

  prevSlide() {
    this.swiper.swiperRef.slidePrev();
  }

  checkFirstOrLastSlide() {
    if (this.APP_IS_ON_DESKTOP) {
      if (this.swiper.swiperRef.isBeginning) {
        this.enablePrevBtn = false;
        this.enableNextBtn = true;
      } else if (this.swiper.swiperRef.isEnd) {
        this.enablePrevBtn = true;
        this.enableNextBtn = false;
      } else {
        this.enablePrevBtn = true;
        this.enableNextBtn = true;
      }
    }
    this.cd.detectChanges();
  }

  handleClick(swiper) {
    // Swiper registers two clicks sometimes and the second one is undefined. Bug? CREW-755
    if (swiper.clickedIndex !== undefined) {
      this.goToCardSlide(swiper.clickedIndex)
    }
  }

}
